import { render, staticRenderFns } from "./TheDoctorsFilters.vue?vue&type=template&id=0b7260e2&scoped=true&"
import script from "./TheDoctorsFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheDoctorsFilters.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TheDoctorsFilters.vue?vue&type=style&index=0&id=0b7260e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7260e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7260e2')) {
      api.createRecord('0b7260e2', component.options)
    } else {
      api.reload('0b7260e2', component.options)
    }
    module.hot.accept("./TheDoctorsFilters.vue?vue&type=template&id=0b7260e2&scoped=true&", function () {
      api.rerender('0b7260e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/TheDoctorsFilters.vue"
export default component.exports